import React from "react";
import { motion } from "framer-motion";
import Top from "../../components/Top";
import OpportunitiesFr from "./OpportunitiesFr";
import LayoutFr from "../../components/LayoutFr";

function OpportuniteFr() {
	return (
		<LayoutFr>
			<Top />
			<>
				<motion.div className="flex flex-1 justify-center mt-6 ">
					<p className=" border-b-8 border-emerald-800 pb-2 text-2xl w-fit text-orange-500">
						Opportunités
					</p>
				</motion.div>
				<p className="flex flex-1 text-sm italic text-black font-extralight justify-center mt-5 ">
				Nous vous tenons au courant des mouvements quotidiens et des tendances dans le monde du développement alternatif.
				</p>
				<div className="flex flex-1">
					<OpportunitiesFr />
				</div>
				<div className="hidden sm:flex text-black font-extralight text-lg mt-4 justify-center">
					<div className="bg-emerald-300 flex space-x-6 rounded-md py-4 px-6">
						<p className="italic"> Votre Email pour rester informer</p>

						<from>
							<div className="flex items-center space-x-4">
								<input
									type="text"
									placeholder="Your Email please"
									className="bg-white px-2 outline-none"
								/>
								<p className=" bg-teal-600 hover:bg-teal-400  px-4 font-light text-white hover:text-black rounded-full cursor-pointer">
									Envoyer
								</p>
							</div>
						</from>
					</div>
          
				</div>

        <div className="bg-emerald-300 flex flex-col sm:hidden items-center space-y-6 rounded-md py-4 mt-6 px-6">
					<p className="italic text-lg">
						{" "}
						Votre Email pour rester informer
					</p>

					<from className="text-lg">
						<div className="flex items-center space-x-4">
							<input
								type="text"
								placeholder="Your Email please"
								className="bg-white px-2 outline-none"
							/>
							<p className=" bg-teal-600 hover:bg-teal-400  px-4 font-light text-white hover:text-black rounded-full cursor-pointer">
								Envoyer
							</p>
						</div>
					</from>
				</div>
			</>
		</LayoutFr>
	);
}

export default OpportuniteFr;
